import React, { useState } from "react";
import { FilterContext } from "./filters-table/context";

const FilterWrapper = ({ children }) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [userList, setUserList] = useState([]);
    const [editData, setEditData] = useState(null);

    return (
        <FilterContext.Provider
            value={{
                dialogOpen,
                setDialogOpen,
                isEditMode,
                setIsEditMode,
                userList,
                setUserList,
                editData,
                setEditData,
            }}
        >
            {children}
        </FilterContext.Provider>
    );
};

export default FilterWrapper;
